import {
  PermissionContext,
  presentationPermissionOperations,
} from '@ardoq/access-control';
import {
  APIPresentationAssetAttributes,
  ArdoqId,
  WithArdoqPersistent,
} from '@ardoq/api-types';
import {
  DEFAULT_SOLUTION_METADATA,
  getSolutionMetadata as getSolutionMetadataFromAsset,
  type SolutionMetadata,
} from '@ardoq/core';
import { PresentationsStreamShape } from './types';

const hasSlides = (presentation: APIPresentationAssetAttributes): boolean => {
  const slides = presentation.slides;
  return Boolean(slides && slides.length);
};

const isEditableOrHasSlides = (
  presentation: APIPresentationAssetAttributes,
  permissionContext: PermissionContext
): boolean => {
  return (
    presentationPermissionOperations.canEditPresentation(
      permissionContext,
      presentation
    ) || hasSlides(presentation)
  );
};

const getPresentationById = (
  presentationsState: PresentationsStreamShape,
  id: ArdoqId
): APIPresentationAssetAttributes | undefined => presentationsState.byId[id];

const getPresentationsList = (
  presentationsState: PresentationsStreamShape
): APIPresentationAssetAttributes[] => presentationsState.list;

const getPresentationThatContainsSlide = (
  presentationsState: PresentationsStreamShape,
  slideId: ArdoqId
) =>
  presentationsState.list.find(presentation =>
    presentation.slides.includes(slideId)
  );

const getSolutionMetadata = (
  presentation: WithArdoqPersistent | undefined
): SolutionMetadata =>
  presentation
    ? getSolutionMetadataFromAsset(presentation)
    : DEFAULT_SOLUTION_METADATA;

export const presentationOperations = {
  hasSlides,
  isEditableOrHasSlides,
  getPresentationById,
  getPresentationsList,
  getPresentationThatContainsSlide,
  getSolutionMetadata,
};
